import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "features/store";
import SetEmailModal, { wasSetEmailDismissed } from "../SetEmailModal";

type ProtectedRouteProps = {
  children: JSX.Element;
};

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  const [emailDismissed, setEmailDismissed] = useState(wasSetEmailDismissed);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isAuthenticated && user && !user.is_pass_reset) {
    return <Navigate to="/reset-password" replace />;
  }

  const needsEmail = Boolean(
    isAuthenticated &&
    user &&
    user.is_pass_reset &&
    !(user.email ?? "").trim() &&
    !emailDismissed,
  );

  const pp = user?.platform_profile;

  if (pp?.is_archived) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {children}
      {needsEmail && (
        <SetEmailModal open={true} onClose={() => setEmailDismissed(true)} />
      )}
    </>
  );
};

export default ProtectedRoute;
